module.exports = __webpack_public_path__ + "img/theme-community.a0ea4180.png";